export interface IActionProps {
  state: any;
  getters: any;
  commit: (mutationName: string, payload: any, params: any) => void;
  dispatch: (actionName: string, payload: any, params: any) => void;
}

export interface IBasicEntity {
  [key: string]: any;
}

export interface IAuthData {
  name?: string;
  token?: string;
  refresh?: string;
}

export interface IResetPasswordParams {
  url: string;
  data: IResetPasswordPayload;
}

export interface IResetPasswordPayload {
  password: string;
  password_confirmation: string;
}

export interface ICatalogRow {
  id: number;
  name: string;
  type: string;
  slug: string;
  sku: string;
  stock?: number;
  price: number;
  image: string;
}

export interface ILocalStore extends Storage {
  token: string;
  name: string;
}

export interface IProductPage {
  data: IProductData;
  meta: IPageMeta;
  error: IError | null;
}

export interface IError {
  status: number;
}

export interface IPageMeta {
  h1?: string;
  title?: string;
  breadcrumbs?: IBreadCrumb[];
  [key: string]: unknown;
}

export interface IBreadCrumb {
  url?: string;
  icon?: string;
  name?: string;
}

export interface IProductData {
  product: IProduct;
}

export interface IProduct {
  id: number;
  slug?: string;
  index?: number;
  images?: Image[];
  info: IProductInfo;
  quantity?: number;
  properties?: IProductProperty[];
  manufacturer?: string;
  price: string | number;
  stock: number;
  total_price?: string | number;
  type?: string;
  onSale?: boolean;
  onDiscount?: boolean;
  promo_start?: string;
  promo_end?: string;
  promo_stock?: number;
  promo_price?: string | number;
}

export interface ITableRowExtended extends IProduct {
  name?: string;
  sku?: string;
  action?: any;
  image?: Image;
  select?: any;
}

export interface Image {
  url: string;
  title: string;
}

export interface IProductInfo {
  title: string;
  description: string;
  retailer: IRetailerData;
}

export interface IRetailerData {
  logo: Image;
  link: string;
}

export interface IProductProperty {
  label: string;
  value?: string;
  sort?: number;
}

export interface IProductAddParams {
  id: number;
  quantity: number;
}

export interface IGenericResponse {
  data: any;
  errors: IGenericError | null;
  status: number | null;
}

export interface IRequestParams {
  url: string;
  method: string;
  params?: any;
  data?: any;
}

export interface IGenericError {
  [key: string]: any;
}

export enum ButtonTypes {
  link = "link",
  submit = "submit",
}

export interface IResetContent {
  h1: string;
  message: string;
  inputs?: boolean;
  button?: IButtonData;
}

export interface IButtonData {
  type: ButtonTypes;
  link?: string;
  title: string;
}

export interface User {
  name: string;
  phone?: string;
}
